import { CustomizationGroupStatus } from '../../models/customization';

export const terminalCustomizationGroupStates: CustomizationGroupStatus[] = [
    CustomizationGroupStatus.Failed,
    CustomizationGroupStatus.Succeeded,
    CustomizationGroupStatus.ValidationFailed,
];
